<script>
import IconWrapper from './IconWrapper.vue'
import picto_enterprise from '@/assets/img/picto/3_Enterprise_white.svg'

export default {
  name: 'IconOffer',
  components: {
    IconWrapper
  },
  computed: {
    svg () {
      return picto_enterprise
    }
  }
}
</script>

<template>
  <IconWrapper v-html="svg" class="IconOffer" />
</template>
